var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, ElementRef, Renderer, ChangeDetectorRef } from "@angular/core";
import { SearchModel } from "../interface/ticketingsystem/search.model";
import { CustomerService } from "../services/customer.service";
import { LocalStorageService } from 'angular-2-local-storage/dist/local-storage.service';
import { MessageService } from "../../shared/services/message.service";
import { DepartmentService } from "./../services/department.service";
import { Permission } from "../../common/enums/permission.enum";
import { CommonService } from "../../shared/services/common.service";
import { CommonMessage } from "../common/common-messages";
import { DeleteModal } from "../models/delete-modal";
import { TicketTabInfo } from "../models/tickets-tab.model";
import { DistributorInfo } from "../interface/ticketingsystem/distributor-info";
import * as moment from 'moment';
import { environment } from "../../../environments/environment";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { OperatingCountryEnums } from "../enums/countries.enums";
import { MemberTypeEnum } from "../enums/member-type.enum";
var TicketsComponent = /** @class */ (function () {
    function TicketsComponent(messageService, _localStorageService, departmentService, _commonService, _customerservice, renderer, chRef) {
        this.messageService = messageService;
        this._localStorageService = _localStorageService;
        this.departmentService = departmentService;
        this._commonService = _commonService;
        this._customerservice = _customerservice;
        this.renderer = renderer;
        this.chRef = chRef;
        // Create Ticket Event Emitter
        this.onCreateTicket = new EventEmitter();
        this.onActiveTicketTab = new EventEmitter();
        this.FBOManageTicketPermissions = [
            Permission.MANAGE_TICKETS_CREATE,
            Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
            Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
            Permission.MANAGE_TICKETS_VIEW
        ];
        this.viewCreateTicket = false;
        this.myTickets = new Array();
        this.tickets = [];
        this.showAllTickets = true;
        this.showTeamTickets = false;
        this.ticketTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.departmentOnDeSelect = true;
        this.departmentOnSelect = true;
        this.sourceOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.tabId = 1;
        this.isLoading = false;
        this.isSearchClicked = false;
        this.pageNumber = 1;
        this.pageSize = 25;
        this.pageCount = 0;
        this.isDesc = true;
        this.pageSizes = [10, 25, 50, 75];
        this.sortColumn = "TICKET_NUMBER";
        this.sort = "DESC";
        this.memberTypeEnum = MemberTypeEnum;
        /**
         * Pagination instance - to avoid console warnings - inorder to assign id for pagination
         */
        this.paginationInstance = {
            id: 'fbo-tickets-pagination',
            itemsPerPage: 10,
            currentPage: 1
        };
        this.dropdownSettings = {
            sourceDropdownList: [],
            sourceSelectedItems: [],
            sourceIndex: 1,
            typeDropdownList: [],
            typeSelectedItems: [],
            typeIndex: 2,
            subTypeDropdownList: [],
            subTypeSelectedItems: [],
            subTypeIndex: 3,
            statusDropdownList: [],
            statusSelectedItems: [],
            statusIndex: 4,
            settings: {},
            departmentIndex: 5,
            departmentDropdownList: [],
            priorityIndex: 6,
            priorityDropdownList: [],
        };
    }
    TicketsComponent.prototype.ngOnInit = function () {
        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'csp-tickets';
        }
        this.setFocusToTextBox();
        this.intializeMultiselectDropdowns();
        this.renderer.invokeElementMethod(this.ticketType.nativeElement, 'focus');
        this._id = this.fboid;
        this.userInfo = this._localStorageService.get("UserInfo");
        this.ticketSearchModel = new SearchModel;
        this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"), AccessLevel.Customer_Service);
        this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[1] + "]"), AccessLevel.Customer_Service);
        this.isTicketAddNoteNotes = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[2] + "]"), AccessLevel.Customer_Service);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"), AccessLevel.Customer_Service);
        this.countryId = this.getAllowedCountries();
        this.getOperatingCountries();
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        this.getTicketStatus();
        this.showAllTickets = true;
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.getDepartments();
        this.getTicketPriorities();
        this.subTypesSort();
        this.ticketTypesSort();
        var ticketTypeElement = document.getElementById('ticketType');
        if (ticketTypeElement) {
            ticketTypeElement.focus();
        }
    };
    ;
    TicketsComponent.prototype.doNotRemoveFormData = function () {
        //data should not be removed...
    };
    TicketsComponent.prototype.openDropDown = function (element) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute("hidden");
    };
    TicketsComponent.prototype.onDropDowneBlur = function (element) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute("hidden", "true");
    };
    TicketsComponent.prototype.goToViewTicket = function (id, ticketNumber) {
        if (this.isTicketView) {
            var ticketTab = new TicketTabInfo();
            ticketTab.distributorID = this.fboid;
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = ticketNumber; //"View Ticket - "+
            ticketTab.viewTicket = true;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
    };
    TicketsComponent.prototype.getTicketPriorities = function () {
        var _this = this;
        this._customerservice.getTicketPriorities().subscribe(function (response) {
            if (response) {
                _this.ticketPriorities = response;
                _this.ticketPriorities.sort(function (item1, item2) {
                    var priority1 = item1.value.toLowerCase(), priority2 = item2.value.toLowerCase();
                    if (priority1 < priority2)
                        return -1;
                    if (priority1 > priority2)
                        return 1;
                    return 0;
                });
                _this.ticketPriorities.forEach(function (item) {
                    _this.dropdownSettings.priorityDropdownList.push({ id: item.id, itemName: item.value });
                });
                _this.dropdownSettings.prioritySelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.priorityDropdownList));
            }
        });
    };
    TicketsComponent.prototype.getDepartments = function () {
        var _this = this;
        this._customerservice.getAllDepartmentsByOperatingCountryId(this.countryId).subscribe(function (response) {
            if (response) {
                _this.departments = response;
                _this.departments.sort(function (item1, item2) {
                    var dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase();
                    if (dept1 < dept2)
                        return -1;
                    if (dept1 > dept2)
                        return 1;
                    return 0;
                });
                if (!_this.userInfo.hasSystemRole) {
                    if (_this.userInfo.privileges.departments && _this.userInfo.privileges.departments.length > 0) {
                        var departmentIds_1 = _this.userInfo.privileges.departments.map(function (a) { return a.id; });
                        _this.departments = _this.departments.filter(function (item) {
                            return departmentIds_1.indexOf(item.id) != -1;
                        });
                    }
                }
                _this.departments.forEach(function (item) {
                    _this.dropdownSettings.departmentDropdownList.push({ id: item.id, itemName: item.value });
                });
                _this.dropdownSettings.departmentSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.departmentDropdownList));
            }
        });
    };
    /**
    * display alert box if the logged in user do not have permission to see the fbo/retail information
    */
    TicketsComponent.prototype.displayAlertbox = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    };
    TicketsComponent.prototype.sortTableByColumn = function (sortColumn) {
        // this.pageNumber = 1;
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? "DESC" : "ASC";
        this.sortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.myTickets.length === 0) {
            return;
        }
        this.getTicketsSearch();
    };
    TicketsComponent.prototype.intializeMultiselectDropdowns = function () {
        this.dropdownSettings.sourceDropdownList = [];
        this.dropdownSettings.sourceSelectedItems = [];
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.statusDropdownList = [];
        this.dropdownSettings.statusSelectedItems = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.priorityDropdownList = [];
        this.dropdownSettings.prioritySelectedItems = [];
        this.dropdownSettings.settings = {
            text: "Select..",
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            classes: "myclass custom-class",
            badgeShowLimit: 1,
        };
    };
    TicketsComponent.prototype.getTicketTypesAndSubTypes = function () {
        var _this = this;
        this.departmentService.getTicketTypesAndSubTypes(this.countryId).subscribe(function (response) {
            if (response) {
                _this.ticketTypes = response;
                _this.ticketTypes.forEach(function (item) {
                    _this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: item.value.trim() });
                    if (item.value.trim().includes('FLP360')) {
                        item.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + item.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                        });
                    }
                    else {
                        item.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name });
                        });
                    }
                    _this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.subTypeDropdownList));
                });
                _this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
                    var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2)
                        return -1;
                    if (tickettype1 > tickettype2)
                        return 1;
                    return 0;
                });
                _this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
                    var ticketsubtype1 = item1.itemName.toLowerCase(), ticketsubtype2 = item2.itemName.toLowerCase();
                    if (ticketsubtype1 < ticketsubtype2)
                        return -1;
                    if (ticketsubtype1 > ticketsubtype2)
                        return 1;
                    return 0;
                });
                _this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.typeDropdownList));
            }
        });
    };
    TicketsComponent.prototype.getSourceTypes = function () {
        var _this = this;
        this._customerservice.getSourceTypes().subscribe(function (response) {
            if (response) {
                _this.sourceTypes = response;
                _this.sourceTypes.sort(function (item1, item2) {
                    var source1 = item1.value.toLowerCase(), source2 = item2.value.toLowerCase();
                    if (source1 < source2)
                        return -1;
                    if (source1 > source2)
                        return 1;
                    return 0;
                });
                _this.sourceTypes.forEach(function (item) {
                    _this.dropdownSettings.sourceDropdownList.push({ id: item.id, itemName: item.value });
                });
                _this.dropdownSettings.sourceSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.sourceDropdownList));
            }
        });
    };
    TicketsComponent.prototype.getTicketStatus = function () {
        var _this = this;
        this._customerservice.getTicketStatus().subscribe(function (response) {
            if (response) {
                _this.statusTypes = response;
                _this.statusTypes.sort(function (item1, item2) {
                    var status1 = item1.value.toLowerCase(), status2 = item2.value.toLowerCase();
                    if (status1 < status2)
                        return -1;
                    if (status1 > status2)
                        return 1;
                    return 0;
                });
                _this.statusTypes.forEach(function (item) {
                    _this.dropdownSettings.statusDropdownList.push({ id: item.id, itemName: item.value });
                });
                _this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.statusDropdownList));
            }
        });
    };
    TicketsComponent.prototype.getSubTypes = function (ticketTypeId) {
        if (ticketTypeId && ticketTypeId !== "undefined") {
            var types = JSON.parse(JSON.stringify(this.ticketTypes));
            this.subTypes = types.find(function (item) { return item.id === ticketTypeId; }).subTypes;
        }
        else {
            this.subTypes = [];
        }
    };
    TicketsComponent.prototype.updatePaginationVariables = function () {
        this.pageNumber = 1;
        this.pageSize = 10;
        this.pageCount = 0;
        this.isDesc = false;
        this.sort = this.isDesc ? "DESC" : "ASC";
    };
    TicketsComponent.prototype.createTicket = function () {
        // this.onCreateTicket.emit();
        var ticketTab = new TicketTabInfo();
        ticketTab.distributorID = this.fboid;
        ticketTab.isNewTicket = true;
        ticketTab.title = "Create Ticket";
        this.messageService.setCustomerServiceUserTabContent(ticketTab);
        //this.tabId++;
    };
    /**
      * On Page change
      * @param pageNumber
      */
    TicketsComponent.prototype.pageChange = function (pageNumber) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.getTicketsSearch();
        }
    };
    /**
     * search with ticket number
     */
    TicketsComponent.prototype.searchWithTicketNumber = function () {
        if (this.ticketSearchModel.ticketNumber) {
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: true });
            this.chRef.detectChanges();
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
            this.OnTabSearchFocus();
        }
        else {
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: false });
            this.chRef.detectChanges();
        }
    };
    TicketsComponent.prototype.onSearch = function () {
        var _this = this;
        this.pageNumber = 1;
        if (this.operatingCountries) {
            this.countryMap = new Map();
            this.operatingCountries.forEach(function (country) {
                _this.countryMap.set(country.id, country.name);
            });
            this.getTicketsSearch();
        }
    };
    TicketsComponent.prototype.getTicketsSearch = function () {
        var _this = this;
        if (this.fboid) {
            this.isLoading = true;
            this._customerservice.SearchTicketsOnPagination((this.fboid), null, this.ticketSearchModel.ticketNumber, (this.isSearchClicked && this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !this.ticketSearchModel.ticketNumber ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.isSearchClicked && this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !this.ticketSearchModel.ticketNumber ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), (this.isSearchClicked && this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !this.ticketSearchModel.ticketNumber ? this.dropdownSettings.sourceSelectedItems.map(function (item) { return item.id; }) : []), (this.isSearchClicked && this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !this.ticketSearchModel.ticketNumber ? this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }) : []), (this.isSearchClicked && this.dropdownSettings.statusSelectedItems.map(function (item) { return item.id; })), (this.isSearchClicked && this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map(function (item) { return item.id; }) : []), this.pageNumber, this.pageSize, this.sortColumn, this.sort).subscribe(function (response) {
                if (response) {
                    _this.pageCount = response["totalCount"];
                    _this.myTickets = response["content"];
                    if (_this.myTickets && _this.myTickets.length) {
                        _this.myTickets.forEach(function (x) {
                            x.operatingCountryName = _this.countryMap.get(x.operatingCountryId);
                            if (x.dueDate) {
                                x.dueDate = moment.utc(x.dueDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.createdDate) {
                                x.createdDate = moment.utc(x.createdDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.modifiedDate) {
                                x.modifiedDate = moment.utc(x.modifiedDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                        });
                    }
                    _this.isLoading = false;
                }
                else {
                    _this.pageCount = 0;
                    _this.myTickets = [];
                    _this.isLoading = false;
                }
            });
        }
    };
    TicketsComponent.prototype.onItemSelect = function (item, indexValue) {
        var _this = this;
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                var selectedIds_1 = this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(function (item) { return selectedIds_1.some(function (index) { return index === item.id; }); }).forEach(function (type) {
                    _this.ticketTypesSort();
                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            _this.ticketTypeOnSelectAll = false;
                        });
                    }
                    else {
                        type.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name });
                            _this.ticketTypeOnSelectAll = false;
                        });
                    }
                });
                if (this.ticketTypes.length === this.dropdownSettings.typeSelectedItems.length) {
                    this.ticketTypeOnSelectAll = true;
                }
                else {
                    this.ticketTypeOnSelectAll = false;
                }
            }
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.statusTypes.length === this.dropdownSettings.statusSelectedItems.length) {
                this.statusOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
            if (this.sourceTypes.length === this.dropdownSettings.sourceSelectedItems.length) {
                this.sourceOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
            if (this.dropdownSettings.subTypeDropdownList.length === this.dropdownSettings.subTypeSelectedItems.length) {
                this.subTypeOnSelectAll = true;
                this.subTypesSort();
            }
            else {
                this.subTypeOnSelectAll = false;
            }
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
            if (this.departments.length === this.dropdownSettings.departmentSelectedItems.length) {
                this.departmentOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
            if (this.ticketPriorities.length === this.dropdownSettings.prioritySelectedItems.length) {
                this.priorityOnSelectAll = true;
            }
        }
    };
    TicketsComponent.prototype.onItemDeSelect = function (item, indexValue) {
        var _this = this;
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                var selectedIds_2 = this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(function (item) { return selectedIds_2.some(function (index) { return index === item.id; }); }).forEach(function (type) {
                    _this.subTypesSort();
                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            _this.ticketTypeOnSelectAll = false;
                            _this.ticketTypesSort();
                        });
                    }
                    else {
                        type.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name });
                            _this.ticketTypeOnSelectAll = false;
                            _this.ticketTypesSort();
                        });
                    }
                });
            }
            else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
            }
        }
        else if (this.dropdownSettings.typeIndex === +indexValue) {
            this.departmentOnSelect = false;
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
    };
    TicketsComponent.prototype.onSelectAll = function (items, indexValue) {
        var _this = this;
        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.ticketTypes.forEach(function (type) {
                _this.ticketTypesSort();
                if (type.value.trim().includes('FLP360')) {
                    type.subTypes.forEach(function (subType) {
                        _this.subTypesSort();
                        var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                        _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                    });
                }
                else {
                    type.subTypes.forEach(function (subType) {
                        _this.subTypesSort();
                        _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name });
                    });
                }
            });
            this.ticketTypeOnSelectAll = true;
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = true;
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = true;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = true;
            this.subTypesSort();
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = true;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = true;
        }
    };
    TicketsComponent.prototype.onDeSelectAll = function (items, indexValue) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.ticketTypeOnSelectAll = false;
            this.ticketTypesSort();
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.ticketTypesSort();
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }
    };
    TicketsComponent.prototype.setFocusToTextBox = function () {
        setTimeout(function () {
            var ticketTypeElement = document.getElementById("ticketType");
            if (ticketTypeElement) {
                ticketTypeElement.focus();
            }
        }, 1000);
    };
    TicketsComponent.prototype.OnTabEventRecentlyViewed = function () {
        var ticketTypeElement = document.getElementById("ticketType");
        if (ticketTypeElement) {
            ticketTypeElement.focus();
        }
        event.preventDefault();
    };
    TicketsComponent.prototype.OnTabSearchFocus = function () {
        var searchButtonElement = document.getElementById("searchbutton");
        if (searchButtonElement) {
            searchButtonElement.focus();
        }
        event.preventDefault();
    };
    TicketsComponent.prototype.clearFields = function () {
        this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: false });
        this.chRef.detectChanges();
        this.setFocusToTextBox();
        this.intializeMultiselectDropdowns();
        this.renderer.invokeElementMethod(this.ticketType.nativeElement, 'focus');
        this._id = this.fboid;
        this.userInfo = this._localStorageService.get("UserInfo");
        this.ticketSearchModel = new SearchModel;
        this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"), AccessLevel.Customer_Service);
        this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[1] + "]"), AccessLevel.Customer_Service);
        this.isTicketAddNoteNotes = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[2] + "]"), AccessLevel.Customer_Service);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"), AccessLevel.Customer_Service);
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        this.getTicketStatus();
        this.onSearch();
        this.showAllTickets = true;
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.getDepartments();
        this.getTicketPriorities();
        var ticketTypeButton = document.getElementById('ticketType');
        if (ticketTypeButton) {
            ticketTypeButton.focus();
        }
        this.ticketTypeOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.sourceOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.isSearchClicked = false;
    };
    TicketsComponent.prototype.subTypesSort = function () {
        this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
            var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
            if (tickettype1 < tickettype2)
                return -1;
            if (tickettype1 > tickettype2)
                return 1;
            return 0;
        });
    };
    TicketsComponent.prototype.ticketTypesSort = function () {
        this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
            var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
            if (tickettype1 < tickettype2)
                return -1;
            if (tickettype1 > tickettype2)
                return 1;
            return 0;
        });
    };
    TicketsComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        this._customerservice.getAllBusinessEntities().subscribe(function (response) {
            if (response) {
                _this.operatingCountries = response;
                _this.onSearch();
                var countryInfo = _this.operatingCountries.find(function (country) { return country.id === _this.countryId; });
                //let countryInfo = {id : 0, name : this.fieldTypes.ALL, value:this.fieldTypes.ALL };
                if (countryInfo) {
                    _this.operatingCountries.splice(_this.operatingCountries.indexOf(countryInfo), 1);
                    _this.operatingCountries.splice(0, 0, countryInfo);
                }
            }
        });
    };
    TicketsComponent.prototype.getAllowedCountries = function () {
        var countryIds = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(",");
                countryIds.sort(function (id1, id2) {
                    if (id1 < id2)
                        return -1;
                    if (id1 > id2)
                        return 1;
                    return 0;
                });
                return countryIds[0];
            }
        }
        return OperatingCountryEnums.USA;
    };
    TicketsComponent.prototype.ShowTicketAndDepatrmentBycountry = function (countryId) {
        this.countryId = countryId;
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.departments = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.assignedToDropdownList = [];
        this.dropdownSettings.assignedToSelectedItems = [];
        this.getTicketTypesAndSubTypes();
        this.getDepartments();
    };
    return TicketsComponent;
}());
export { TicketsComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/tickets.component.ts.pre-build-optimizer.js